import useParticipants from 'features/video-conference/hooks/useParticipants';
import useScreenShareParticipant from 'features/video-conference/hooks/useScreenShareParticipant';

export default function useMainParticipant() {
  const screenShareParticipant = useScreenShareParticipant();
  const participants = useParticipants();

  return screenShareParticipant || participants[0];
}
